



























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { FORMAT_CURRENCY } from '@/utils/formatPrice';
import Loading from '@/components/Loading.vue';
import { GetterNames } from "@/constants/GetterNames";
import { ActionNames } from "@/constants/ActionNames";
import * as moment from 'moment';
import { IOrder } from "@/interfaces/IOrder";

@Component({
  components: {
    Loading,
  },
})
export default class TransactionList extends Vue {
  public date = moment;

  public loading: boolean = true;

  public orders: IOrder[] = [];

  public currentPageNumber: number = 1;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public formatCurrency = (price: number): string => FORMAT_CURRENCY(price);

  get allOrders(): IOrder[] {
    return this.$store.getters[GetterNames.ORDER_HISTORY];
  }

  public async mounted() {
    const success = await this.$store.dispatch(ActionNames.ORDER_HISTORY);

    if (!success) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het ophalen van je transacties',
      };

      return;
    }

    this.loading = false;
    this.paginate();
  }

  public paginate() {
    const orders = this.allOrders;
    let pageNumber = this.currentPageNumber;

    this.orders = orders.slice(--pageNumber * 10, (pageNumber + 1) * 10);
  }

  @Watch('currentPageNumber', { immediate: true, deep: true })
  public onPaginate() {
    this.paginate();
  }
}
